import { DesignSystem } from "../design-system";
import { ListboxStyles, ListboxTemplate } from "@fluentui/web-components";
import { Listbox } from "./listbox";
/**
 * The Listbox element definition.
 *
 * @public
 * @remarks
 * HTML Element: `<fabric-listbox>`
 */
export const definition = Listbox.compose({
    name: `${DesignSystem.prefix}-listbox`,
    template: ListboxTemplate,
    styles: ListboxStyles,
    shadowOptions: {
        delegatesFocus: true
        // No slotAssignment needed for listbox based on temp implementation
    }
});
//# sourceMappingURL=listbox.definition.js.map